import { toConsumableArray as _toConsumableArray, defineProperty as _defineProperty } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { interaction___dashShort, interaction___checkmark } from '@lsg/icons';
import React from 'react';
import { cleanupClassObject } from '../../utils/DomUtils.js';
import { fComp } from '../../utils/React.js';
import { IconLinkWrapper } from '../IconLink/IconLinkWrapper.js';
import { IndicatorWrapper } from '../Indicator/IndicatorWrapper.js';
import { NavigationItemWrapper } from '../NavigationItem/NavigationItemWrapper.js';
import { ParagraphPresentation } from '../Paragraph/ParagraphPresentation.js';
import { mainClass } from './NavigationBlock.styles.js';

var defaultProps = {
  startLevel: "topic",
  groupsAlwaysHighlighted: false,
  onChange: function onChange() {
    /* empty */
  }
};
var renderLevel = function renderLevel(navigation, level, value, activeRef, isProcessNavigation, onChange, openObject, onOpenObjectChange, expandAll, navigationActionAs, groupsAlwaysHighlighted) {
  var _cleanupClassObject;
  var successorLevel = level === "topic" ? "group" : "page";
  return /*#__PURE__*/React.createElement("div", {
    className: cleanupClassObject((_cleanupClassObject = {}, _defineProperty(_cleanupClassObject, "".concat(mainClass, "-group"), true), _defineProperty(_cleanupClassObject, "".concat(mainClass, "__page-group"), level === "page"), _cleanupClassObject)),
    role: "list",
    style: {
      position: "relative"
    }
  }, navigation.map(function (n) {
    var emptyIcon = function emptyIcon() {
      return '<svg width="24" height="24" />';
    };
    var icon = n.name === value && interaction___dashShort || n.completed && interaction___checkmark || emptyIcon;
    var onClick = function onClick(e) {
      if (n.collapsible && !n.active && !expandAll) {
        onOpenObjectChange(Object.assign(Object.assign({}, openObject), _defineProperty({}, n.name, !openObject[n.name])));
      }
      if (!n.collapsible) onChange(n.name, e);
      if (n.onClick) n.onClick(e, n.name);
    };
    var isOpen = expandAll || n.defaultOpen || openObject[n.name] || n.active;
    return /*#__PURE__*/React.createElement("div", {
      role: "listitem",
      key: n.name
    }, level === "page" ? /*#__PURE__*/React.createElement(IconLinkWrapper, Object.assign({}, n, {
      innerRef: n.name === value ? activeRef : undefined,
      secondary: !n.active,
      icon: isProcessNavigation && icon,
      iconColor: n.name === value ? "primary" : undefined,
      onClick: onClick,
      actionAs: n.actionAs || navigationActionAs
    }), n.label) : /*#__PURE__*/React.createElement(NavigationItemWrapper, Object.assign({}, n, {
      level: level,
      secondary: !n.active && !(groupsAlwaysHighlighted && level === "group"),
      onClick: onClick,
      innerRef: n.name === value ? activeRef : undefined,
      actionAs: n.actionAs || navigationActionAs
    }), n.label), n.children && isOpen && renderLevel(n.children, successorLevel, value, activeRef, isProcessNavigation, onChange, openObject, onOpenObjectChange, expandAll, navigationActionAs, groupsAlwaysHighlighted));
  }));
};
var reducer = function reducer(value) {
  return function (acc, item) {
    var _a;
    var children = (_a = item.children) === null || _a === void 0 ? void 0 : _a.reduce(reducer(value), []);
    var active = (children === null || children === void 0 ? void 0 : children.some(function (child) {
      return child.active;
    })) || value === item.name;
    return [].concat(_toConsumableArray(acc), [Object.assign(Object.assign({}, item), {
      children: children,
      active: active
    })]);
  };
};
var getActiveItemLevel = function getActiveItemLevel(items) {
  var level = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var item = items.find(function (i) {
    return i.active;
  });
  if (item) {
    return item.children ? getActiveItemLevel(item.children, level + 1) : level + 1;
  }
  return level;
};
var NavigationBlockPresentation = fComp(function (props) {
  var _cleanupClassObject2;
  var navigationTree = props.navigationTree,
    navigationActionAs = props.navigationActionAs,
    clusterLabel = props.clusterLabel,
    startLevel = props.startLevel,
    value = props.value,
    activeRef = props.activeRef,
    activeElement = props.activeElement,
    isProcessNavigation = props.isProcessNavigation,
    onChange = props.onChange,
    openObject = props.openObject,
    onOpenObjectChange = props.onOpenObjectChange,
    expandAll = props.expandAll,
    noIndent = props.noIndent,
    style = props.style,
    alwaysShowIndicator = props.alwaysShowIndicator,
    groupsAlwaysHighlighted = props.groupsAlwaysHighlighted;
  var navigationTreeInternal = navigationTree.reduce(reducer(value), []);
  var activeItemLevel = getActiveItemLevel(navigationTreeInternal) || 0;
  var indicatorOffsetIndent = Math.max({
    topic: -3,
    group: -2,
    page: -1
  }[startLevel] + activeItemLevel, -1);
  var showIndicator = indicatorOffsetIndent >= 0 || alwaysShowIndicator;
  var indicatorOffset = noIndent ? -1 : indicatorOffsetIndent;
  return /*#__PURE__*/React.createElement("div", {
    className: cleanupClassObject((_cleanupClassObject2 = {}, _defineProperty(_cleanupClassObject2, mainClass, true), _defineProperty(_cleanupClassObject2, "".concat(mainClass, "__process"), isProcessNavigation), _defineProperty(_cleanupClassObject2, "".concat(mainClass, "__indent"), !noIndent), _cleanupClassObject2)),
    style: style
  }, !isProcessNavigation && /*#__PURE__*/React.createElement(IndicatorWrapper, {
    direction: "vertical",
    activeElement: showIndicator ? activeElement : undefined,
    noAnimation: !showIndicator,
    translateOrthogonal: indicatorOffset * 16
  }), clusterLabel && /*#__PURE__*/React.createElement(ParagraphPresentation, {
    className: "".concat(mainClass, "__cluster-item"),
    size: "helper-text",
    noMargin: true
  }, clusterLabel), renderLevel(navigationTreeInternal, startLevel, value, activeRef, isProcessNavigation, onChange, openObject, onOpenObjectChange, expandAll, navigationActionAs, groupsAlwaysHighlighted));
}, defaultProps);
NavigationBlockPresentation.displayName = "NavigationBlockPresentation";

export { NavigationBlockPresentation };
